import {
  GET_SIGNET_EXAMPLE_LIST_PAGEABLE,
  GET_SIGNET_EXAMPLE_LIST_START,
  GET_SIGNET_EXAMPLE_LIST_ERROR,
  ADD_SIGNET_EXAMPLE,
  ADD_SIGNET_EXAMPLE_START,
  ADD_SIGNET_EXAMPLE_ERROR,
} from '../actions/types';

const initialState = {
  loading: false,
  error: undefined,
  signetExampleList: [],
  totalElements: '',
};

const addSignetExampleStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const addSignetExample = (state, action) => {
  return {
    ...state,
    loading: false,
    signetExampleList: [action.payload],
  };
};

const addSignetExampleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllSignetExampleStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllSignetExampleError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllSignetExamplePageable = (state, action) => {
  return {
    ...state,
    loading: false,
    signetExampleList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_SIGNET_EXAMPLE:
      return addSignetExample(state, action);
    case ADD_SIGNET_EXAMPLE_START:
      return addSignetExampleStart(state);
    case ADD_SIGNET_EXAMPLE_ERROR:
      return addSignetExampleError(state, action);

    // case CLEAR_ERROR_SIGNET_EXAMPLE:
    //   return clearError(state);

    case GET_SIGNET_EXAMPLE_LIST_PAGEABLE:
      return findAllSignetExamplePageable(state, action);
    case GET_SIGNET_EXAMPLE_LIST_START:
      return findAllSignetExampleStart(state);
    case GET_SIGNET_EXAMPLE_LIST_ERROR:
      return findAllSignetExampleError(state, action);

    default:
      return state;
  }
}
